var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"width":"100%","height":"100%"}},[_c('div',{staticClass:"v-table-loading",style:({'opacity':_vm.loadingOpacity})}),_c('div',{staticClass:"v-table-loading-content",domProps:{"innerHTML":_vm._s(_vm.loadingContent)}})])}
var staticRenderFns = []

export { render, staticRenderFns }